export enum ChipType {
  ACTION,
  FILTER,
  INPUT,
  DROPDOWN
}
